var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "scenarios" } },
    [
      _c("el-alert", {
        attrs: { title: _vm.message.message, type: _vm.message.type }
      }),
      _vm._v(" "),
      _vm.availability &&
      (_vm.availability.availability_before ||
        _vm.availability.availability_after)
        ? _c(
            "div",
            { staticClass: "alternatives" },
            [
              _vm.availability.availability_before
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.tryAt(_vm.availability.availability_before)
                        }
                      }
                    },
                    [_vm._v("Try at " + _vm._s(_vm.availabilityBefore))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.availability.availability_after
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.tryAt(_vm.availability.availability_after)
                        }
                      }
                    },
                    [_vm._v("Try at " + _vm._s(_vm.availabilityAfter))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", { attrs: { title: _vm.error, type: "error" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.getAvailabilityStatus != "failure" &&
      _vm.getFilteredScenariosStatus != "failure"
        ? _c(
            "el-collapse",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value:
                    _vm.getAvailabilityStatus == "pending" ||
                    _vm.getFilteredScenariosStatus == "pending",
                  expression:
                    "getAvailabilityStatus == 'pending' || getFilteredScenariosStatus == 'pending'"
                }
              ],
              ref: "collapse",
              attrs: { accordion: _vm.isMobileWidth },
              on: { change: _vm.onSectionChange },
              model: {
                value: _vm.activeSections,
                callback: function($$v) {
                  _vm.activeSections = $$v
                },
                expression: "activeSections"
              }
            },
            _vm._l(_vm.mergedScenarios, function(scenario, i) {
              return _c(
                "el-collapse-item",
                {
                  class: { available: scenario && scenario.total_price > 0 },
                  attrs: { name: i }
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c("h3", [_vm._v(_vm._s(scenario.name))]),
                      _vm._v(" "),
                      scenario.total_price > 0 &&
                      _vm.settings.default_players_type == "adults_and_juniors"
                        ? _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _c("i18n-n", {
                                attrs: {
                                  value: +scenario.total_price,
                                  format: "currency"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "content", attrs: { shadow: "never" } },
                    [
                      _c("div", { staticClass: "description" }, [
                        _c("img", {
                          attrs: { src: scenario.picture_id },
                          on: {
                            click: function($event) {
                              return _vm.selectPackage(scenario)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-text" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(scenario.description)
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      scenario.total_price > 0
                        ? _c(
                            "div",
                            { staticClass: "select-package" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectPackage(scenario)
                                    }
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Select Package")]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-right"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _c("div", { staticClass: "availability-message" }, [
                            _c("p", [
                              _vm._v(
                                "Sorry, this option is only available during the following times:"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "availability-message-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  scenario.notes_for_web_customers
                                )
                              }
                            })
                          ])
                    ]
                  )
                ],
                2
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }